import { Button, Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import SerialNumberTable from "../components/selectDocument_components/serialNumberTable_components/SerialNumberTable";
import DocumentTable from "../components/generic_components/documentTable_components/DocumentTable";
import { DocumentStruct } from "../common/Interfaces";
import { fetchSimDocumentsToken } from "../authentication/AuthenticationHelper";
import { fetchGetDocuments } from "../api/simDocuments/DocumentService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";

export default function SelectDocument() {
  const location = useLocation();
  const hide: boolean = process.env.REACT_APP_HIDE === "true";
  const selectDocumentState = location.state?.selectDocumentState;
  const [documentResults, setDocumentResults] = useState<DocumentStruct[]>(
    selectDocumentState.documentResults || []
  );
  const [serialNumber, setSerialNumber] = useState<string | null>(null);
  const [loadDocuments, setLoadDocuments] = useState(false);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const token = await fetchSimDocumentsToken();
      if (token) {
        try {
          const documentsList = await fetchGetDocuments({
            ProductCompany: null,
            SerialNumber: serialNumber || null,
            Models: null,
            ProductNumbers: null,
            token,
          });
          setDocumentResults(documentsList || []);
        } catch (error: any) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            const errors = error.response.data.errors;
            const messages = errors.map((err: any) => err.message);
            if (errors[0].type != "NotFound") {
              setErrorMessages(messages);
            }
          }
        } finally {
          setLoadDocuments(false);
        }
      }
    };

    if (loadDocuments && serialNumber) {
      setErrorMessages([]);
      setDocumentResults([]);
      fetchData();
    }
  }, [serialNumber]);

  return (
    <>
      <Row>
        <h5>Serial Number Results</h5>
      </Row>
      <Row>
        <SerialNumberTable
          basicMachineInformationResults={
            selectDocumentState.basicMachineInformationResults
          }
          onSelect={(row) => {
            if (row?.serialNumber != serialNumber) {
              setSerialNumber(row?.serialNumber || null);
              setLoadDocuments(true);
            }
          }}
        />
      </Row>
      {errorMessages.map((errorMessage) => (
        <label className="errorMessage">{errorMessage}</label>
      ))}
      <Row className="margin">
        <Col xs={5}>
          <h5>Document Results</h5>
        </Col>
        <Col className="text-end">
          {!hide && (
            <Button className="btn btn-primary btn-sm">
              <FontAwesomeIcon icon={faFileExcel} /> Download Excel
            </Button>
          )}
        </Col>
      </Row>
      <DocumentTable
        loading={loadDocuments}
        exclude={false}
        noAction={false}
        documentResults={documentResults}
      />
    </>
  );
}
